import { z } from 'zod';

export const DEPENDENCY_TYPE = {
  SUCCESSOR: 'SUCCESSOR',
  PREDECESSOR: 'PREDECESSOR',
} as const;

// Required field, but unknown/unspecified values are represented as null (not a synthetic enum member).
export const dependencyTypeSchema = z.enum(DEPENDENCY_TYPE).nullable();

export const itemDependencySchema = z.object({
  type: dependencyTypeSchema,
  itemId: z.number().int().positive(),
});

export type DependencyType = z.infer<typeof dependencyTypeSchema>;
export type ItemDependencyDTO = z.infer<typeof itemDependencySchema>;
